<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/monitor")
          i.fa.fa-eye
          span.ml-1 {{ $t("ui.monitor") }}
      b-breadcrumb-item
        router-link(to="/match/ibcmatch")
          i.fa.fa-futbol
          span.ml-1 {{ $t("ui.ibc") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row(v-if="detailShow && matchInfo").animated.fadeIn
            div.col
              table.tablex(style="width: 100%;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position(width=100)
                      span {{ $t('ui.id') }}
                    th.sticky-position(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th.sticky-position
                      span {{ $tc("ui.leagues", 1) }}
                    th.sticky-position(width=200)
                      span {{ $t("ui.home") }}
                    th.sticky-position(width=200)
                      span {{ $t("ui.away") }}
                    th.sticky-position(width=80)
                      span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                    th.sticky-position(width=80)
                      span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                    th.sticky-position(width=80)
                      span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                tbody
                  tr
                    td
                      span {{ matchInfo.match_id }}
                    td
                      span {{ matchInfo.sport_type }}
                    td
                      span(:title="matchInfo.league_name") {{ matchInfo.league_name }}
                    td
                      span(:title="matchInfo.home_team") {{ matchInfo.home_team }}
                    td
                      span(:title="matchInfo.away_team") {{ matchInfo.away_team }}
                    td.text-uppercase
                      span {{ matchInfo.market_type }}
                    td
                      span {{ $moment(matchInfo.match_date).format("YYYY-MM-DD") }}
                    td
                      span {{ matchInfo.match_time }}
          div.row(v-if="!detailShow")
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="ibcMatchSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-1.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $t("ui.id") }}
                    b-form-radio(value="league_name") {{ $tc("ui.leagues", 1) }}
                    b-form-radio(value="home_team") {{ $t("ui.home") }}
                    b-form-radio(value="away_team") {{ $t("ui.away") }}

                  //- DateRangePicker(
                  //-   v-model="dateRange"
                  //-   :locale-data="locale"
                  //-   :autoApply="true"
                  //-   :showDropdowns="true"
                  //- )
                  //- div(slot="input" slot-scope="picker")
          div.row(v-if="!detailShow")
            div.col-md-12.mb-1
              div.form-row
                //- div.col-md-2.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.far.fa-clock
                //-     b-form-select(v-model="marketType" @change="marketOnChange($event)")
                //-       option(value="") {{ $t('ui.all') }}
                //-       option(value="early") {{ $t('ui.early') }}
                //-       option(value="today") {{ $t('ui.today') }}
                //-       option(value="live") {{ $t("ui.live") }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="sortKey")
                //-       option(value="match_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="league_name") {{ $tc("ui.leagues", 1) }}
                //-       option(value="match_date_time") {{ $t("ui.match_datetime") }}
                //-     b-form-select(v-model="sortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getIBCMatchList(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div(v-if="!detailShow")
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="ibcMatchTotalRow"
                  :per-page="getPageSize"
                  v-model="currentIBCMatchPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                  b-input(:value="ibcMatchTotalRow" readonly)
            div.row.clusterize
              div.col-md-12.clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width=100 @click="sortOrder('match_id')")
                        span {{ $t('ui.id') }}
                        i(:class="changeSortKey('match_id')")
                      th.sticky-position(width=80 @click="sortOrder('sport_type')")
                        span {{ $tc('ui.sports', 1) }}
                        i(:class="changeSortKey('sport_type')")
                      th.sticky-position(@click="sortOrder('league_name')")
                        span {{ $tc("ui.leagues", 1) }}
                        i(:class="changeSortKey('league_name')")
                      th.sticky-position(width=200 @click="sortOrder('home_team')")
                        span {{ $t("ui.home") }}
                        i(:class="changeSortKey('home_team')")
                      th.sticky-position(width=200 @click="sortOrder('away_team')")
                        span {{ $t("ui.away") }}
                        i(:class="changeSortKey('away_team')")
                      //- th.sticky-position(width=80)
                      //-   span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                      th.sticky-position(width=80 @click="sortOrder('match_date_time')")
                        span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                        i(:class="changeSortKey('match_date_time')")
                      //- th(width=100).text-center
                      //-   span {{ $t("ui.is_live") }}
                      th.sticky-position(width=80)
                        span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                      //- th(width=200)
                      //-   span {{ $t("ui.epoch_time") }}
                      th.sticky-position(width=80)
                        span(:title="$t('ui.match_link')") {{ $t("ui.linked") }}
                      th.sticky-position(width=60)
                        span(:title="$t('ui.running_score')") {{ $t("ui.short.running_score") }}
                      th.sticky-position(width=60)
                        span(:title="$t('ui.running_time')") {{ $t("ui.short.running_time") }}
                      th.sticky-position(width=50)
                        span(:title="$t('ui.home_red_card')") {{ $t("ui.short.home_red_card") }}
                      th.sticky-position(width=50)
                        span(:title="$t('ui.away_red_card')") {{ $t("ui.short.away_red_card") }}
                      th.sticky-position(width=200)
                        span(:title="$t('ui.parent_league')") {{ $t("ui.short.parent_league") }}
                      th.text-center.sticky-position(width=80)
                        span {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="ibcMatchList.length == 0")
                      td(colspan="14").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in ibcMatchList")
                      td
                        span
                          b-link.clickable(href="javascript:void(0);" @click="getOddsInfo(item)") {{ item.match_id }}
                      td
                        span(:title="item.sport_type") {{ item.sport_type }}
                      td
                        span(:title="item.league_name") {{ item.league_name }}
                      td
                        span(:title="item.home_team") {{ item.home_team }}
                      td
                        span(:title="item.away_team") {{ item.away_team }}
                      //- td.text-uppercase
                      //-   span {{ item.market_type }}
                      td
                        span(:title="getDate(item.match_date)") {{ getDate(item.match_date) }}
                      //- td.text-center
                      //-   span
                      //-     i(:class="{'fas fa-check': item.is_live, 'fas fa-times': !item.is_live  }")
                      td
                        span(:title="item.match_time") {{ item.match_time }}
                      //- td
                      //-   span {{ item.epoch_time }}
                      td
                        span(:title="item.match_link") {{ item.match_link }}
                      td
                        span(:title="item.running_score") {{ item.running_score }}
                      td
                        span(:title="item.running_time") {{ item.running_time }}
                      td
                        span(:title="item.hrc") {{ item.hrc }}
                      td
                        span(:title="item.arc") {{ item.arc }}
                      td
                        span(:title="item.parent_league")  {{ item.parent_league }}
                      td.actions
                        span
                          a.fa.fa-trash.text-primary(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
          div(v-if="detailShow")
            div.mb-1
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="hideDetail()"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
              SubmitButton(
                :loading="loading"
                icon="icon-reload"
                :text="$t('ui.refresh')"
                type="button"
                @click="refresh()"
                variant="info"
                size="sm"
                ).mb-1
            div.row.mb-3(v-if="groups")
              div.col
                b-form-radio-group(v-model="selectedGroup" :options="groupItems" buttons button-variant="outline-primary" size="sm" @change="resetLog" :disabled="loading")
            div.row.mb-5(v-if="selectedGroup").animated.fadeIn
              div.col
                div.row
                  div.col-md-6.clusterize
                    .clusterize-scroll(style="max-width: 820px;")
                      table.tablex(style="width: 100%; table-layout: auto;")
                        thead
                          tr
                            th.text-center.sticky-position(v-for="(v, k) in details[selectedGroup][0]")
                              span(v-if="k == 'epoch_time'") DateTime
                              span(v-else) {{ k }}
                        tbody.clusterize-content
                          tr(v-for="item in details[selectedGroup]")
                            td.text-uppercase.text-center
                              span
                                b-link.clickable(href="javascript:void(0);" @click="getLogs(item)" v-if="!loading") {{ item["odds_id"] }}
                                span(v-else) {{ item["odds_id"] }}
                            td.text-uppercase.text-center(v-for="(v, k) in item" v-if="k != 'odds_id'" style="min-width: 40px;")
                              span(v-if="k!='epoch_time'") {{ v }}
                              span(v-else) {{ $moment(v / 1000000).format("YYYY-MM-DD hh:mm:ss.SSS A") }}
                  div(v-if="loading").col-md-6.clusterize.animated.fadeIn
                    i
                      div.fa.fa-spinner.fa-spin
                  div(v-if="logs && !loading").col-md-6.animated.fadeIn
                    div.row
                      div.col-md-4
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="ibcOddsTotalRow"
                          :per-page="getPageSize"
                          v-model="currentIBCOddsPage"
                          @input="changedOddsPage($event)").mb-1
                      div.col-md-3
                        b-input-group(size="sm")
                          b-input-group-text(slot="prepend")
                            span {{ $t("ui.from") }}
                          date-picker(v-model="dStartDate" :config="localeWithTime" @blur.native="refresh()")
                      div.col-md-3
                        b-input-group(size="sm")
                          b-input-group-text(slot="prepend")
                            span {{ $t("ui.to") }}
                          date-picker(v-model="dEndDate" :config="localeWithTime" @blur.native="refresh()")
                      div.col-md-2
                        b-input-group(size="sm").mb-1
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedOddsPageSize")
                          b-input(:value="ibcOddsTotalRow" readonly)
                    div.clusterize-scroll(style="max-height: 300px; max-width: 820px;")
                      table.tablex(style="width: 100%; table-layout: auto;" v-if="logs && logs.length > 0 && !loading")
                        thead
                          tr
                            th.text-center.sticky-position(v-for="(v, k) in logs[0]")
                              span {{ k }}
                        tbody.clusterize-content
                          tr(v-for="(v, k) in logs")
                            td(v-for="(i, j) in v")
                              span.text-uppercase {{ i }}
                      table.tablex(style="width: 100%; table-layout: auto;" v-else)
                        thead
                          tr
                            th
                              span &nbsp;
                        tbody.clusterize-content
                          tr
                            td(colspan="100%").text-center
                              span {{ $t('message.no_data_available') }}
            div.row.mb-1(v-if="logs && logs.length > 0 && !loading").animated.fadeIn
              div.col
                div.row
                  div.d-flex.justify-content-center.align-items-center#chart
                    apexchart(type="line" height="350" width="1600" :options="options" :series="series")
    //- ibcmatchinfo(ref="ibcMatchInfo" @failed="handleFailed" :item="info")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";

import ibcmatchinfo from "@/components/match/ibcMatchInfo.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    ibcmatchinfo
  },
  data: () => ({
    loading: false,
    matchInfo: null,
    sportType: 1,
    sportList: [],
    ibcMatchList: [],
    currentIBCMatchPage: 1,
    ibcMatchTotalRow: 0,
    currentIBCOddsPage: 1,
    ibcOddsTotalRow: 0,
    ibcMatchSearch: "",
    marketType: "",
    currentOddsDetailInfo: null,
    sortKey: "league_name",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    filterBy: "league_name",
    startDate: null,
    endDate: null,
    dStartDate: null,
    dEndDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    localeWithTime: {
      format: 'YYYY-MM-DD hh:mm A',
      useCurrent: false,
      showClear: true,
      showClose: true,
    },
    // dateRange: {
    //   startDate: new Date(),
    //   endDate: new Date()
    // },
    // locale: {
    //   direction: "ltr",
    //   format: "YYYY-MM-DD",
    //   separator: " - ",
    //   weekLabel: "W",
    //   firstDay: 1
    // },
    detailShow: false,
    oddsInfo: null,
    logs: null,
    selectedGroup: null,
    series: [],
    options: {
      chart: {
        id: 'chart'
      },
      xaxis: {
        type: 'datetime',
        categories:[],
        title: {
          text: 'DateTime'
        }
      },
      yaxis: {
        title: {
          text: 'Odds'
        },
      }
    }
  }),
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWD() {
      return this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD');
    },
    tomorrowWD() {
      return this.$moment(new Date).add(1, 'days').add(-12, 'hours').format('YYYY-MM-DD');
    },
    todayWithTime() {
      let time = '23:59';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    yesterdayWithTime() {
      let time = '00:00';
      return this.$moment(this.yesterday+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    groupItems: function() {
      if (this.groups) {
        var list = [];
        for (var prop in this.groups) {
          list.push({
            text: this.groups[prop].bet_type + " (" + this.groups[prop].ot_count + ")",
            value: this.groups[prop].bet_type
          });
        }
        return list;
      } else {
        return null;
      }
    },
    groups() {
      if (this.oddsInfo) {
        return this.oddsInfo["Table"];
      } else {
        return null;
      }
    },
    details() {
      if (this.oddsInfo) {
        return this.oddsInfo;
      } else {
        return null;
      }
    }
  },
  mounted: function() {
    this.getSportList();
    this.startDate = this.yesterday;
    this.endDate = this.today;
    this.dStartDate = this.yesterdayWithTime;
    this.dEndDate = this.todayWithTime;
  },
  methods: {
    marketOnChange(eventStatus) {
      if (eventStatus == '') {
        this.startDate = this.yesterday;
        this.endDate = this.today;
      }
      else if (eventStatus == 'early') {
        this.startDate = this.tomorrowWD;
        this.endDate = this.tomorrowWD;
      } else if (eventStatus == 'today' || eventStatus == 'live') {
        this.startDate = this.todayWD;
        this.endDate = this.todayWD;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getIBCMatchList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    resetLog() {
      this.logs = null;
      this.currentIBCOddsPage = 1;
      this.resetGraphData();
    },
    refresh() {
      if (this.selectedGroup) {
        this.getOddsInfo(this.matchInfo);
        if (this.logs) {
          this.currentIBCOddsPage = 1;
          this.getLogs(this.currentOddsDetailInfo);
        }
      }


    },
    hideDetail() {
      this.detailShow = false;
      this.selectedGroup = null;
      this.info = null;
      this.logs = null;
      this.currentOddsDetailInfo = null;
      this.resetGraphData();
    },
    resetGraphData() {
      this.series = [],
      this.options = {
        chart: {
          stacked: false,
          zoom: {
            type: 'x',
            enabled: true
          },
          toolbar: {
            autoSelected: 'zoom'
          },
          id: 'chart'
        },
        plotOptions: {
          line: {
            curve: 'smooth',
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
          style: 'full',
        },
        xaxis: {
          type: 'datetime',
          categories:[],
          title: {
            text: 'DateTime'
          }
        },
        yaxis: {
          title: {
            text: 'Odds'
          },
        },
        tooltip: {
          shared: false,
          y: {
            formatter: function (val) {
              return val.toFixed(2)
            }
          },
          x: {
            format: "yyyy-MM-dd hh:mm:ss"
          }
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        legend: {
          formatter: function(val) {
            return val.toUpperCase();
          }
        }
      }
    },
    getOddsInfo: function(item) {
      this.matchInfo = item;
      this.detailShow = true;
      this.getOddsDetailInfo(item);
    },
    getOddsDetailInfo: function (val) {
      if (!val) {
        return;
      }

      if (!val.match_id) {
        return;
      }

      let url = config.ibcMatchOddsInfoUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        match_id: val.match_id,
        page_id: config.accessRoles.ibcmatch
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.oddsInfo = response.data.tbl_ibc_match_odds_info;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLogs(val) {
      if (!val) {
        return;
      }

      if (!val.odds_id) {
        return;
      }

      this.currentOddsDetailInfo = val;

      let url = config.ibcMatchOddsLogsUrl();



      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        group_id: this.selectedGroup,
        odds_id: val.odds_id,
        page_id: config.accessRoles.ibcmatch,
        page_number: this.currentIBCOddsPage,
        page_size: this.getPageSize,
        date_from: this.dStartDate,
        date_to: this.dEndDate,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              this.ibcOddsTotalRow = response.data.tbl_ibc_match_odds_logs["Table"].length > 0 ? response.data.tbl_ibc_match_odds_logs["Table"][0].totalrows : 0;

              if (this.feedback.success == true) {
                var n = response.data.tbl_ibc_match_odds_logs["Table"];
                var m = [];
                for (var i in n) {
                  var ep = n[i].epoch_time / 1000000;
                  n[i].timestamp = this.$moment(ep).format("YYYY-MM-DD hh:mm:ss.SSS A");
                  delete n[i].epoch_time;
                  delete n[i].row_id;
                  delete n[i].odds_id;
                  delete n[i].match_id;
                  delete n[i].ot;
                  delete n[i].totalrows;
                  m.push(n[i]);
                }
                this.logs = m;

                this.resetGraphData();

                for (var i = 0; i < this.logs.length; i++) {
                  if (this.logs[i].hasOwnProperty('timestamp')) {
                    this.options.xaxis.categories.push(this.$moment(new Date(this.logs[i]['timestamp'])).format("YYYY-MM-DD hh:mm:ss"));
                    // this.options.xaxis.categories.push(this.$moment(this.logs[i]['timestamp']).format("YYYY-MM-DD hh:mm:ss"));
                  }
                }

                for (var prop in this.logs[0]) {
                  if (prop != 'timestamp' && prop != 'mt' && prop != 'fhdpt' && prop != 'hhdpt') {
                    var json = { name: prop, data:[] };
                    for (var i = 0; i < this.logs.length; i++) {
                      if (this.logs[i].hasOwnProperty(prop)) {
                        json.data.push(this.logs[i][prop]);
                      }
                    }
                    this.series.push(json);
                  }
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.ibcmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getIBCMatchList: function(isSearch) {
      let url = config.ibcMatchListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentIBCMatchPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.ibcmatch,
        sport_id: this.sportType,
        market_type: this.marketType,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentIBCMatchPage,
        page_size: this.getPageSize
      };

      if (this.filterBy == "id") {
        json.match_id = this.ibcMatchSearch;
      } else if (this.filterBy == "league_name") {
        json.league_name = this.ibcMatchSearch;
      } else if (this.filterBy == "home_team") {
        json.home_team = this.ibcMatchSearch;
      } else if (this.filterBy == "away_team") {
        json.away_team = this.ibcMatchSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ibcMatchList = response.data.tbl_ibc_match_list;
                this.ibcMatchTotalRow = this.ibcMatchList.length > 0 ? this.ibcMatchList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onDelete(item) {
      this.purgeMatch(item);
    },
    purgeMatch: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.purge_match"),
          text: this.$t("message.purge_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPurgeMatch(item);
          }
        });
    },
    confirmPurgeMatch(item) {
      let url = config.purgeIBCMatchUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.ibcmatch,
        match_id: item.match_id,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.getIBCMatchList(true);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentIBCMatchPage = 1;
      this.getIBCMatchList();
    },
    changedPage: function(pageNo) {
      this.currentIBCMatchPage = pageNo;
      this.getIBCMatchList();
    },
    changedOddsPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentIBCOddsPage = 1;
      this.getLogs(this.currentOddsDetailInfo);
    },
    changedOddsPage: function(pageNo) {
      this.currentIBCOddsPage = pageNo;
      this.getLogs(this.currentOddsDetailInfo);
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>